import pinia from "@/stores/index.js";
import { defineStore } from "pinia";

const useCustomerStore = defineStore("customer", {
  state: () => {
    return {
      customers: [],
      scope: "all",
      page: 1,
      pageCount: 0,
      perPage: 50,
      queryString: "",
      currentCustomer: {},
      pagination: {},
    };
  },
});

export const storeCustomer = useCustomerStore(pinia);
